import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "";
const cfg = { withCredentials: true };
const post = (path, body) => axios.post(`${API_BASE}/api/account/${path}`, body || {}, cfg).then((r) => r.data);

export const login = (email, password, remember) => post("login", { email, password, remember: !!remember });
export const logout = () => post("logout");
export const me = () => axios.get(`${API_BASE}/api/account/me`, cfg).then((r) => r.data);
export const forgot = (email) => post("forgot", { email });
export const setPassword = (token, password, remember) => post("set-password", { token, password, remember: !!remember });
export const changePassword = (current, next) => post("change-password", { current_password: current, new_password: next });

// 2026-10-26 own preferences (PATCH /api/account/prefs): { style_profit_search: bool }
export const savePrefs = (prefs) => axios.patch(`${API_BASE}/api/account/prefs`, prefs, cfg).then((r) => r.data);

export const errMsg = (err, fallback = "Something went wrong. Please try again.") =>
  (err && err.response && err.response.data && err.response.data.detail) ||
  (err && err.response ? fallback : "Cannot reach the server. Check your connection.");
